// NOTE: import file extensions are required for native ecmascript / sveltekit. ts is smart enough to know to ignore them.
import { MEME_MAKER_URL } from "./index.js";
import * as handlers from "./handlers.js";
/** Make a meme! */
export function start({ 
/** Reference to the iframe which will house the meme maker. */
iframe, 
/** Customize the appearance of the meme maker. */
styleVariables = {}, 
/** Set the host for the meme maker iframe. */
makerHost = MEME_MAKER_URL, 
/** Skip the "insert meme button" and send the meme immediately when it's ready instead. */
skipInsertButton = false, }) {
    return new Promise((resolve, reject) => {
        // Set the iframe src to the meme maker page
        iframe.src = `${makerHost}${skipInsertButton ? "?skipInsertButton=true" : ""}`;
        // Cleanup function to remove the event listener
        const cleanup = () => {
            window.removeEventListener("message", messageHandler, false);
        };
        // Wrap resolve and reject to cleanup when promise is settled
        const wrappedResolve = (value) => {
            cleanup();
            resolve(value);
        };
        const wrappedReject = (reason) => {
            cleanup();
            reject(reason);
        };
        // Create the message handler with the wrapped resolve and reject functions
        const messageHandler = handlers.create(iframe, styleVariables, wrappedResolve, wrappedReject);
        window.addEventListener("message", messageHandler, false);
    });
}
//# sourceMappingURL=client.js.map